import { cn } from "~/lib/utils";

import { getAllergenInfo } from "./get-allergen-info";
import { AllergenItem } from "./allergen-item";
import { type AllergenLanguageCode } from "./constants";

type AllergensProps = {
  allergens: string[];
  showLabel: boolean;
  highlightAllergens?: string[];
  languageCode: AllergenLanguageCode;
  className?: string;
  iconClassName?: string;
  allergenClassName?: string;
};

const Allergens = ({
  allergens,
  highlightAllergens = [],
  languageCode,
  className,
  iconClassName,
  allergenClassName,
  showLabel = true
}: AllergensProps) => {
  return (
    <div
      className={cn(
        "flex flex-wrap items-start justify-start gap-1",
        className
      )}
    >
      {allergens.map((allergen) => {
        const info = getAllergenInfo({
          name: allergen,
          languageCode
        });

        return (
          <AllergenItem
            key={allergen}
            label={showLabel ? info.label : undefined}
            faIcon={info.faIcon}
            iconImage={info.iconImage}
            isHighlighted={highlightAllergens.includes(allergen)}
            className={allergenClassName}
            iconClassName={iconClassName}
          />
        );
      })}
    </div>
  );
};

type AllergensIconsProps = Omit<AllergensProps, "languageCode" | "showLabel">;

export const AllergensIcons = (props: AllergensIconsProps) => {
  return <Allergens {...props} languageCode="en" showLabel={false} />;
};

type AllergensLabeledProps = Omit<AllergensProps, "showLabel">;

export const AllergensLabeled = (props: AllergensLabeledProps) => {
  return <Allergens {...props} showLabel />;
};
